module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/narrow-col-action-block/narrow-col-action-block.component.scss
// module id = ./src/app/modules/common-module/components/narrow-col-action-block/narrow-col-action-block.component.scss
// module chunks = 9